import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import ScrollToTopOnNavigate from '@/components/base/ScrollToTopOnNavigate';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ScrollToTopOnNavigate />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <ScrollToTop />
    </>
  );
}